import { useCallback, useMemo } from 'react'
import { Stack, TextField } from '@mui/material'
import useGetExtendedColumns from '../../generic/hooks/useGetExtendedColumns/useGetExtendedColumns'

export const useWorkflowResourceExtendedColumns = (t_) => {
  const extendedColumns = useGetExtendedColumns('workflow_resource')

  const { changeMgmtColumns, filteredExtendedColumns } = useMemo(() => {
    const cols = extendedColumns || []

    const changeMgmtSet = new Set(
      [t_('Version'), t_('Revision BOM'), t_('Index')].map(l => (l || '').toLowerCase())
    )
    const changeMgmtColumns = []
    const filteredExtendedColumns = []

    cols.forEach(col => {
      const name = (col?.name || '').toLowerCase()
      ;(changeMgmtSet.has(name) || changeMgmtSet.has(name + ' bom') ? changeMgmtColumns : filteredExtendedColumns).push(col)
    })

    return { changeMgmtColumns, filteredExtendedColumns }
  }, [extendedColumns, t_])

  const withExtendedColumns = useCallback(
    (baseColumns) =>
      filteredExtendedColumns?.length
        ? [...baseColumns, ...filteredExtendedColumns]
        : baseColumns,
    [filteredExtendedColumns]
  )

  const withExtendedColumnsPrefix = useCallback(
    (baseColumns, prefix) =>
      filteredExtendedColumns?.length
        ? [
            ...baseColumns,
            ...filteredExtendedColumns.map(col => ({
              ...col,
              field: prefix + col.field
            }))
          ]
        : baseColumns,
    [filteredExtendedColumns]
  )

  return { changeMgmtColumns, withExtendedColumns, withExtendedColumnsPrefix }
}

export const computeChangeMgmtValues = ({ rows = [], changeMgmtColumns = [], valueGetter }) => {
  const values = Object.fromEntries(changeMgmtColumns.map(col => [col.field, '']))

  for (const row of rows) {
    for (const col of changeMgmtColumns) {
      if (values[col.field]) continue

      const val = valueGetter ? valueGetter(row, col) : row?.[col.field]
      if (val !== undefined && val !== null && val !== '') {
        values[col.field] = val
      }
    }

    if (Object.values(values).every(Boolean)) break
  }

  return values
}

export const areObjectValuesEqual = (a = {}, b = {}) =>
  Object.keys(a).length === Object.keys(b).length &&
  Object.keys(a).every(key => a[key] === b[key])

export const buildChangeMgmtToolbar = ({ changeMgmtColumns = [], changeMgmtValues = {}, enabled = true }) => {
  if (!enabled || !changeMgmtColumns.length) return

  return {
    render: {
      fetchFunction: () => (
        <Stack direction='row' spacing={2} alignItems='center'>
          {changeMgmtColumns.map(col => (
            <TextField
              key={col.field}
              label={col.name}
              value={changeMgmtValues[col.field] ?? ''}
              InputProps={{ readOnly: true }}
              disabled
            />
          ))}
        </Stack>
      )
    }
  }
}
